import React, { useState, useEffect } from "react";
import "../../../components/Styles/FormStyle.css";
import "../../../components/Styles/SecondPage.css";
import { secret } from "../data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

const CompanyDetails = (props) => {
  const [loading, setLoading] = useState(true);
  const [judgments, setJudgments] = useState([]);

  const fetchJudgments = async () => {
    var body = { companyId: props.companyId };
    await fetch("https://api.twojeskd.pl/get_judgments_id_company", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secret,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setJudgments(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchJudgments();
  };

  useEffect(() => {
    getData();
  }, []);

  const destkop = (
    <>
      <div
        style={{
          position: "fixed",
          top: "5vh",
          width: "90vw",
          maxHeight: "80vh",
          overflow: "scroll",
          backgroundColor: "white",
          zIndex: "3",
          padding: "20px",
          borderRadius: "5px",
          boxShadow: "-2px -2px 29px 0px rgba(66, 68, 90, 1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "right",

            alignItems: "center",
          }}
        >
          <div style={{ width: "80%" }}>
            <img
              style={{
                width: "30%",
              }}
              src={props.logo}
            />
          </div>
          <div
            style={{
              width: "20%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "right",
            }}
          >
            <p
              style={{
                position: "fixed",
                fontWeight: "900",
                color: "red",
                cursor: "pointer",
                textAlign: "right",
                margin: "0",
                paddingRight: "10px",
              }}
              onClick={props.close}
            >
              zamknij okno
            </p>
          </div>
        </div>
        <div style={{ fontSize: "1vw" }}>
          <p style={{ textTransform: "uppercase" }}>{props.description}</p>
          <div>
            <img style={{ width: "100%" }} src={props.image}></img>
          </div>
          <div>
            <p
              style={{
                margin: "0",
                margin: "20px 0px",
                textTransform: "uppercase",
              }}
            >
              Przykładowe wyroki:
            </p>
            <div>
              {loading ? (
                <span>ładowanie wyroków...</span>
              ) : (
                <>
                  {judgments.length === 0 ? (
                    <span>
                      kancelaria nie opublikowała jeszcze przykładowych wyroków
                    </span>
                  ) : (
                    <>
                      <table
                        className="companyOfferTable"
                        style={{
                          width: "100%",
                          fontSize: "1vw",
                          borderRadius: "5px",
                        }}
                      >
                        <tbody>
                          <tr>
                            <th
                              style={{
                                width: "10%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Data
                            </th>
                            <th
                              style={{
                                width: "15%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Sygnatura
                            </th>
                            <th
                              style={{
                                width: "15%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Sąd
                            </th>
                            <th
                              style={{
                                width: "15%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Bank
                            </th>

                            <th
                              style={{
                                width: "15%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Notatka
                            </th>
                          </tr>
                          {judgments
                            .sort(function (a, b) {
                              return new Date(b.date) - new Date(a.date);
                            })
                            .map((el) => (
                              <tr key={el.id}>
                                <td>{el.date}</td>
                                <td>{el.sygn}</td>
                                <td>{el.court}</td>
                                <td>{el.bank}</td>
                                <td>{el.note ? el.note : "brak notatki"}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const mobile = (
    <>
      <div
        style={{
          position: "fixed",
          top: "5vh",

          maxHeight: "80vh",
          overflow: "scroll",
          backgroundColor: "white",
          zIndex: "3",
          padding: "20px",
          borderRadius: "5px",
          boxShadow: "-2px -2px 29px 0px rgba(66, 68, 90, 1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "right",

            alignItems: "center",
          }}
        >
          <div style={{ width: "60%" }}>
            <img
              style={{
                width: "80%",
              }}
              src={props.logo}
            />
          </div>
          <div
            style={{
              width: "40%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "right",
            }}
          >
            <p
              style={{
                fontWeight: "900",
                color: "red",
                cursor: "pointer",
                textAlign: "right",
                margin: "0",
                paddingRight: "10px",
              }}
              onClick={props.close}
            >
              zamknij okno
            </p>
          </div>
        </div>
        <div style={{ fontSize: "3vw" }}>
          <p style={{ textTransform: "uppercase" }}>{props.description}</p>
          <div>
            <img style={{ width: "100%" }} src={props.image}></img>
          </div>
          <div>
            <p
              style={{
                margin: "0",
                margin: "20px 0px",
                textTransform: "uppercase",
              }}
            >
              Przykładowe wyroki:
            </p>
            <div>
              {loading ? (
                <span>ładowanie wyroków...</span>
              ) : (
                <>
                  {judgments.length === 0 ? (
                    <span>
                      kancelaria nie opublikowała jeszcze przykładowych wyroków
                    </span>
                  ) : (
                    <>
                      <table
                        className="companyOfferTable"
                        style={{
                          width: "100%",
                          fontSize: "2vw",
                          borderRadius: "5px",
                        }}
                      >
                        <tbody>
                          <tr>
                            <th
                              style={{
                                width: "10%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Data
                            </th>
                            <th
                              style={{
                                width: "15%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Sygnatura
                            </th>
                            <th
                              style={{
                                width: "15%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Sąd
                            </th>
                            <th
                              style={{
                                width: "15%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Bank
                            </th>

                            <th
                              style={{
                                width: "15%",
                                padding: "0",
                                backgroundColor: "rgb(116, 164, 188)",
                                color: "white",
                                fontWeight: "900",
                                textTransform: "uppercase",
                              }}
                            >
                              Notatka
                            </th>
                          </tr>
                          {judgments
                            .sort(function (a, b) {
                              return new Date(b.date) - new Date(a.date);
                            })
                            .map((el) => (
                              <tr key={el.id}>
                                <td>{el.date}</td>
                                <td>{el.sygn}</td>
                                <td>{el.court}</td>
                                <td>{el.bank}</td>
                                <td>{el.note ? el.note : "brak notatki"}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="destkopView">{destkop}</div>
      <div className="mobileView">{mobile}</div>
    </>
  );
};

export default CompanyDetails;
